import React, { useEffect, useState } from "react";
import "../assets/OnboardLicense.css";
import "../assets/OnboardMBN.css";
import { fetchData, postFormData} from "../api/restapi";
import Select from "react-select";
import uploadIcon from '../assets/upload.svg';
import ConfirmationDialog from "../popups/ConfirmationDialog";
import Popup from "../popups/popup";


function DeltaMBNTab() {
  const [inputText, setInputText] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [chipsets, setChipsets] = useState([]);
  const [chipset, setChipset] = useState(null);

  const [inputLabelDiv, setInputLabelDiv] = useState({color:'gray'})
  const [inputDivMessage, setInputDivMessage] = useState("Click here to select a file")
  const [chooseFileStyle, setChooseFileStyle] = useState({})
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");



  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    try{
      setUploadedFile(file);
      setInputDivMessage("File selected: " + file.name)
      setInputLabelDiv({})
    } catch (err) {
      setInputDivMessage("Click here to select a file")
      setInputLabelDiv({color:'gray'})
      console.warn(err)
    }
  };

  useEffect(() => {
  
    fetchData("/qfm/v1/solutions/portal/chipsets")
    .then((data) => {
        const filteredChipsets = data.chipsets.filter(chipset => chipset.name !== 'ALL');
        setChipsets([
            { value: 'ALL', label: 'Any' }, // Static option
            ...filteredChipsets.map((chipset) => ({
                value: chipset.name,
                label: `${chipset.name}: ${chipset.description}`
            }))
        ]);
    });

    }, []);

  const handleSubmit = () => {
    setShowConfirmation(true);
  };

  const handleConfirm = () => {
    const formData = new FormData();
    formData.append("mbn", uploadedFile);
    formData.append("mbn-description", inputText);
    formData.append("chipset", chipset.value);
    formData.append("user", "Srivatsa");

    postFormData("/qfm/v1/solutions/mbn", formData)
    .then((response) => {
      if (response.error) {
        setErrorMessage("There was an error in onboarding the Delta MBN ");
      } else {
        setSuccessMessage("Onboarded Delta MBN Successfully!");
      }
    })
    .catch((err) => setErrorMessage("There was an error in onboarding the Delta MBN "));

    setShowConfirmation(false);
  };

  const handleCancel = () => {
    setShowConfirmation(false);
  };

  const closePopup = () => {
    setSuccessMessage("");
    setErrorMessage("");
    window.location.reload();
  };


  return (
    <div className="lsn-tab-container">
      <div className="tab-heading">
        <h1>New Delta MBN Onboarding</h1>
      </div>

      <div className="row">

        <div className="dropdown-section">
          <div className='dropdown-heading'>Delta MBN Description<span className="required-asterisk">*</span></div>
          <input
            className="delta-mbn-description" 
            type="text"
            placeholder="Enter text"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
          />
        </div>

        <div className="dropdown-section">
          <div className='dropdown-heading'>Chipset<span className="required-asterisk">*</span></div>
          <Select
            className="dropdown multi-select"
            options={chipsets}
            value={chipset}
            onChange={setChipset}
            placeholder="Select..."
          />
        </div>
        
      </div>

      <div className="licenseOnboardingTab-file-upload-group">
        <div className='upload-file-section'>
            <h4>Upload Delta MBN File<span className="required-asterisk">*</span></h4>
            <p>Browse file</p>
            <div id="add-device-input-and-submit-div">
                <div className="input-container">
                    <label style={inputLabelDiv} htmlFor="choose-file-to-upload-csv-button" className="custom-label">
                        {inputDivMessage}
                    <img className="upload-icon" src={uploadIcon} alt="Upload Icon" />
                    </label>
                    <input id="choose-file-to-upload-csv-button" className="choose-file-button custom-input" style={chooseFileStyle} type="file" onChange={handleFileUpload} />
                </div>
            </div>
        </div>
      </div>

      <div className='submit-button-section'>
        <button className="submit-button" onClick={handleSubmit}>Onboard Delta MBN</button>
      </div>

      {showConfirmation && (
        <ConfirmationDialog
          message={`Are you sure you want to onboard the following Delta MBN?\n\nFile: ${uploadedFile?.name || "None"}\nDelta MBN Description: ${inputText || "None"}`}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}

      {successMessage && (
        <Popup message={successMessage} onClose={closePopup} />
      )}

      {errorMessage && (
        <Popup message={errorMessage} onClose={closePopup} />
      )}
      
    </div>
  );
}

export default DeltaMBNTab;